import React from 'react'
import { Fade } from 'react-awesome-reveal'

const ManagerLoading = () => {
    return (
        <Fade>
            <div className="d-flex flex-column align-items-center mt-5">
                <a href="https://www.shippersedge.com/">
                    <img src="https://scheduler.shippersedge.com/shippersedge-logo.png" alt="logo" height="150px" />
                </a>
                <span className="TitleText mt-2 mb-4">Dock Scheduler</span>
                <img src="https://scheduler.shippersedge.com/loading.gif" alt="loading icon" height="200px" />
                <div className="mt-2">Loading Appointments....</div>
            </div>
        </Fade>
    )
}

export default ManagerLoading
